import React from 'react'
import { AppBar, Toolbar, Box } from '@mui/material';
import CommonButton from '../../components/CommonButton';
import { ReactComponent as Logo } from '../../assets/images/big-logo.svg';
import { useNavigate } from 'react-router-dom';
import CurrencySlider from './CurrencySlider';


export default function Appbar() {
  const navigate = useNavigate();
  
  return (
    <Box>
      <AppBar position="static" sx={{ bgcolor: '#062B2A', boxShadow: 'none', px: 0 }}>
        <Toolbar sx={{ minHeight: 80, px:0, mx:0 }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            justifyContent: 'space-between',
            width: '100%',
            maxWidth: '1440px',
            mx: 'auto',
            px: { xs: 2, md: 4 }
          }}>
            <Logo style={{ height: 32, width: 'auto' }} />
            <CommonButton
              onClick={() => {
                navigate('/login');
              }}
              label="Giriş Yap"
              color="#fff"
              sx={{
                borderRadius: 8,
                fontSize: 14,
                maxWidth: 100,
              }} />
          </Box>
        </Toolbar>
      </AppBar>
      <CurrencySlider />
    </Box>
  );
}
